import React, { useEffect, useState, useRef } from "react";
import '../../styles/shop.scss';
import { Header } from "../common/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { faMinus, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useCart } from "../../context/CartContext";
import ProductsService from "../../services/productsService";
import { Alert, Button, Card, Col, Row, Spinner } from "react-bootstrap";
import { CartCheck, CartX } from 'react-bootstrap-icons';
import { Box } from "@mui/material";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import { TopBar } from "../common/TopBar";
import { BasketSkeleton } from "../common/Skeletons";
import { EmptyState } from "../common/EmptyState";



/**
 * Renders information about the user obtained from MS Graph
 * @param props 
 */
export const ShopBasket = (props) => {


    const { cart, cartLoaded, fetchCart, addItem: addItemToCart, removeItem: removeItemFromCart, removeTotalItem: removeTotalItemFromCart, clearCart: clearCartFromContext, placeOrder: placeOrderFromContext } = useCart();
    const navigate = useNavigate();
    const productService = ProductsService();
    const location = useLocation();
    const [show, setShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [orderPlaced, setOrderPlaced] = useState(false);
    const [images, setImages] = useState([]);
    const [purchaseOrderNo, setPurchaseOrderNo] = useState("");

    const loadShoppingCart = async () => {
        await fetchCart();
        
        if (cart.items.length > 0) {
            setOrderPlaced(false);
            console.log("ORDER PLACED", orderPlaced)
        }
    };

    useEffect(() => {
        loadShoppingCart();
    }, [location]);

    useEffect(() => {
        const fetchImages = async () => {
            const imgs = [];
            const imgRequests = cart.items.reduce((acc, item) => {
                if (item.productId) {
                    acc.push(productService.getProductImages(item.productId).then(image => imgs[item.productId] = image));
                }
                return acc;
            }, []);
            await Promise.all(imgRequests);
            setImages(imgs);
        };
        
        fetchImages();
    }, [cart]);

    const clearCart = async () => {
        await clearCartFromContext();
    };

    const removeFromCart = async (item, quantity) =>{
        if(quantity === "all"){
            await removeTotalItemFromCart(item);
        }else{
            await removeItemFromCart(item);
        }
    };

    const addItem = async (id) => {
        await addItemToCart(id);
    };

    const placeOrder = async () => {
        setIsLoading(true);
        const placeOrderResult = await placeOrderFromContext({ purchaseOrderNo });
        if(placeOrderResult.success){
            setOrderPlaced(true);
            setShow(true);
            setPurchaseOrderNo(""); // Clear the purchase order field
        }
        setIsLoading(false);
    };

    return (
        <>
        <Header />
            <TopBar />

        
    <div id="shop-div" className="container-fluid py-4">
        <div className="row justify-content-center">
            <Col xs={12} lg={10} xl={8}>
                <Card className="basket-card shadow-sm">
                    <Card.Body className="p-4">
                        <h2 className="basket-title mb-4">Shopping Basket</h2>
                        
                        {/* Order Total Section */}
                        <div className="basket-summary mb-4 p-3">
                            <Row className="align-items-center">
                                <Col>
                                    <h5 className="mb-0">Order Total:</h5>
                                </Col>
                                <Col xs="auto">
                                    <h4 className="mb-0 text-primary fw-bold">{cart.totalPrice}</h4>
                                </Col>
                            </Row>
                        </div>

                        {/* Purchase Order Number Section */}
                        <div className="purchase-order-section mb-4 p-3">
                            <label htmlFor="purchaseOrderNo" className="form-label fw-semibold mb-2">
                                Purchase Order Number <span className="text-muted">(Optional)</span>
                            </label>
                            <input 
                                type="text" 
                                className="form-control form-control-lg" 
                                id="purchaseOrderNo"
                                placeholder="Enter your PO number here..."
                                value={purchaseOrderNo}
                                onChange={(e) => setPurchaseOrderNo(e.target.value.slice(0, 20))}
                                maxLength={20}
                                disabled={isLoading || cart.items.length===0}
                            />
                            <small className="text-muted">
                                Add your purchase order reference for tracking (max 20 characters)
                                {purchaseOrderNo.length > 0 && (
                                    <span className={purchaseOrderNo.length >= 20 ? "text-warning ms-1" : "ms-1"}>
                                        {purchaseOrderNo.length}/20
                                    </span>
                                )}
                            </small>
                        </div>

                        {/* Action Buttons */}
                        <Row className="mb-4 g-3">
                            <Col xs={12} md={6}>
                                <Button 
                                    variant="outline-danger" 
                                    size="lg" 
                                    className="w-100 basket-action-btn"
                                    disabled={isLoading || cart.items.length===0} 
                                    onClick={() => clearCart()}>
                                    <CartX className="me-2" /> Clear Cart
                                </Button> 
                            </Col>
                            <Col xs={12} md={6}>
                                {(!orderPlaced && cart.items.length > 0) && 
                                    <Button 
                                        variant="primary" 
                                        size="lg" 
                                        className="w-100 basket-action-btn"
                                        disabled={isLoading}
                                        onClick={() => placeOrder()}>
                                        {isLoading ? 
                                            <Spinner animation="border" size="sm" className="me-2" /> : 
                                            <CartCheck className="me-2" />
                                        }
                                        Place Order
                                    </Button>
                                }
                            </Col>
                        </Row>

                        {/* Success Alert */}
                        {show && (
                            <Alert 
                                variant="success" 
                                dismissible 
                                onClose={() => setShow(false)}
                                className="mb-4">
                                <Alert.Heading>Order Placed Successfully!</Alert.Heading>
                                <p className="mb-0">Your order has been confirmed and will be processed shortly.</p>
                            </Alert>
                        )}

                        {/* Cart Items */}
                        <div className="basket-items">
                            <h5 className="mb-3">Items ({cart.items.length})</h5>
                            {!cartLoaded ? (
                                <Box sx={{ py: 1 }}>
                                    <BasketSkeleton count={3} />
                                </Box>
                            ) : cart.items.length === 0 ? (
                                <EmptyState
                                    icon={<ShoppingCartOutlinedIcon />}
                                    title="Your basket is empty"
                                    description="Browse the catalogue and add tyres to your basket. They'll be ready to order when you come back."
                                    action={
                                        <Button
                                            variant="primary"
                                            size="lg"
                                            onClick={() => navigate("/shop")}
                                            style={{ display: "inline-flex", alignItems: "center", gap: 8 }}
                                        >
                                            <StorefrontOutlinedIcon fontSize="small" />
                                            Browse shop
                                        </Button>
                                    }
                                />
                            ) : (
                                cart.items.map(item =>
                                    <Card key={item.productId} className="basket-item-card mb-3 shadow-sm">
                                        <Card.Body className="p-3">
                                            <Row className="align-items-center">
                                                <Col xs={3} md={2} className="text-center">
                                                    <div className="basket-item-image">
                                                        {images[item.productId] ?
                                                            <img
                                                                src={`data:image/jpeg;base64,${images[item.productId]}`}
                                                                alt={item.productName || "product"}
                                                                className="img-fluid"
                                                            /> :
                                                            <div className="image-placeholder">
                                                                <Spinner animation="border" variant="primary" size="sm" />
                                                            </div>
                                                        }
                                                    </div>
                                                </Col>
                                                <Col xs={9} md={10}>
                                                    <Row className="align-items-center g-2">
                                                        <Col xs={12} className="mb-2">
                                                            <div className="d-flex justify-content-between align-items-start">
                                                                <div>
                                                                    <h6 className="mb-1 fw-semibold">{item.productName || item.description}</h6>
                                                                    <p className="text-muted small mb-0">{item.productId}</p>
                                                                </div>
                                                                <Button 
                                                                    variant="outline-danger" 
                                                                    size="sm"
                                                                    onClick={() => removeFromCart(item, "all")}
                                                                    disabled={isLoading}>
                                                                    <FontAwesomeIcon icon={faTrash} className="me-1" />
                                                                    Remove
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} md={6}>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <Button 
                                                                    variant="outline-secondary" 
                                                                    size="sm" 
                                                                    className="basket-qty-btn"
                                                                    onClick={() => removeFromCart(item)}
                                                                    disabled={isLoading}>
                                                                    <FontAwesomeIcon icon={faMinus} />
                                                                </Button>
                                                                <span className="basket-qty">{item.quantity}</span>
                                                                <Button 
                                                                    variant="outline-primary" 
                                                                    size="sm" 
                                                                    className="basket-qty-btn"
                                                                    onClick={() => addItem(item.productId)}
                                                                    disabled={isLoading}>
                                                                    <FontAwesomeIcon icon={faPlus} />
                                                                </Button>
                                                            </div>
                                                        </Col>
                                                        <Col xs={6} md={3} className="text-center">
                                                            <small className="text-muted d-block mb-1">Unit Price</small>
                                                            <strong className="d-block">{item.price || '€ 0.00'}</strong>
                                                        </Col>
                                                        <Col xs={6} md={3} className="text-end">
                                                            <small className="text-muted d-block mb-1">Total</small>
                                                            <h5 className="mb-0 fw-bold text-primary">{item.totalPrice || item.total || '€ 0.00'}</h5>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                )
                            )}
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </div>
    </div>
    </>
    );
}
